import React from 'react';
import AdminDashboard from '../AdminDashboard';

const UsersPage = () => <AdminDashboard forcedTab="users" embedded />;

export default UsersPage;
